import React, { useState, useEffect } from "react";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import solisPowerApi from "../../api/solisPowerApi";
import { HEADERS, PROJECT_STATUS_VALUES } from "../../constants/CONSTANT";
import ProgressTracker from "./ProgressTracker";
import Main from "../layout/Main";
import { ROUTES } from "../../constants/webRouting";
import { Link } from "react-router-dom";


const SolisProjectDashboard = () => {
  const [body, setBody] = useState([]);
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [isSearch, setIsSearch] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const result = await solisPowerApi.fetchProjects();
        if (result && Array.isArray(result)) {
          const updatedProjects = result.map((item) => ({
            ...item,
            isShowProduct: true,
          }));
          setProjects(updatedProjects);
          setBody(updatedProjects);
        } else {
          setProjects([]);
          setBody([]);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        setProjects([]);
        setBody([]);
      }
    }
    fetchData();
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setIsSearch(!value);
  };

  const handleSearch = () => {
    const filteredProjects = body.filter((item) =>
      item.project_name?.toLowerCase().includes(search.toLowerCase().trim())
    );
    setProjects(filteredProjects);
  };

  const handleClear = () => {
    setSearch("");
    setIsSearch(true);
    setProjects(body);
  };

  const getProgress = (status) => {
    const index = PROJECT_STATUS_VALUES.findIndex(s => s.label === status);
    return index !== -1 ? index : 0;
  };

  return (
    <Main>
      <Container>
        <Row>
          <Col lg={2} className="mx-3"></Col>
          <h4 className="text-center mb-4">Project Stages Report</h4>
        </Row>
        <Row className="text-center">
          <Col lg={4} style={{ marginLeft: "267px" }}>
            <Form.Control
              type="text"
              placeholder="Search by Project Name"
              value={search}
              onChange={handleChange}
            />
          </Col>
          <Col style={{ marginRight: "420px" }}>
            <Button
              className="btn-md"
              disabled={isSearch}
              onClick={handleSearch}
            >
              Search
            </Button>
            <Button
              variant="link"
              className="btn-md"
              onClick={handleClear}
              disabled={isSearch}
            >
              Clear
            </Button>
          </Col>
        </Row>
        <Row className="mx-3 kanban" style={{ marginTop: "3rem" }}>
          <Row>
            <Col lg={2}></Col>
            <Col lg={10} style={{ paddingLeft: "3rem" }}>
              <Row>
                {HEADERS.map((item) => (
                  <Col
                    className="kanban-column-title"
                    key={item.headerName}
                    style={{
                      backgroundColor: item.backgroundColor,
                      color: item.color,
                    }}
                  >
                    {item.headerName}
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {projects.map((project) => (
            <Row
              key={project.id}
              className="mt-2"
              style={{ border: "2px solid black" }}
            >



              <Col
                as={Link}
                to={`${ROUTES.LEAD.LIST}/${project.lead_id}`}
                lg={2}
                className="project-col mt-3 mb-2 pb-2"
                style={{
                  backgroundColor: "#6c757d",
                  padding: ".5rem",
                  color: "#fff",
                  borderLeft: "10px solid rgb(241 170 42)",
                  textDecoration: "none"
                }}
              >
                {project.project_name}
              </Col>
              <Col lg={10} style={{ paddingLeft: "3rem" }}>
                <Row className="flex-nowrap" style={{ overflowX: "auto" }}>
                  <Col
                    key={project.project_status}
                    className="kanban-item-col"
                    style={{ marginTop: "10px", flex: "0 0 auto" }}
                  >
                    <ProgressTracker
                      currentStep={getProgress(project.project_status)}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          ))}
        </Row>
      </Container>
    </Main>
  );
};

export default SolisProjectDashboard;
